export default __webpack_public_path__ + "static/media/SAL8.9a76e9fa.jpg";